import { z } from 'zod';
import { SourceSystem, StockEntryType } from '../enums.js';
import { DecimalString, IsoDateTime, MoneyAmount, UuidString } from '../primitives.js';

/** Stock Entry document — header. */
export const StockEntry = z.object({
  id: UuidString,
  entity_id: UuidString,
  voucher_no: z.string().min(1),
  stock_entry_type: StockEntryType,
  posting_datetime: IsoDateTime,
  from_warehouse_id: UuidString.nullable(),
  to_warehouse_id: UuidString.nullable(),
  work_order_id: UuidString.nullable(),
  bom_id: UuidString.nullable(),
  remarks: z.string().nullable(),
  is_submitted: z.boolean().default(false),
  is_cancelled: z.boolean().default(false),
  source_system: SourceSystem.default('staiter'),
  source_document_id: z.string().nullable(),
  source_system_ref: z.record(z.unknown()).nullable(),
  fetched_at: IsoDateTime.nullable(),
  created_at: IsoDateTime,
  updated_at: IsoDateTime,
});
export type StockEntry = z.infer<typeof StockEntry>;

/** Stock Entry line item. */
export const StockEntryItem = z.object({
  id: UuidString,
  entity_id: UuidString,
  stock_entry_id: UuidString,
  position: z.number().int().nonnegative(),
  item_id: UuidString,
  from_warehouse_id: UuidString.nullable(),
  to_warehouse_id: UuidString.nullable(),
  batch_id: UuidString.nullable(),
  serial_no: z.string().nullable(),
  qty: DecimalString,
  uom: z.string().min(1),
  conversion_factor: DecimalString.default('1'),
  stock_qty: DecimalString,
  basic_rate: MoneyAmount,
  basic_amount: MoneyAmount,
  additional_cost: MoneyAmount.nullable(),
  is_scrap: z.boolean().default(false),
  created_at: IsoDateTime,
  updated_at: IsoDateTime,
});
export type StockEntryItem = z.infer<typeof StockEntryItem>;
